import React from "react";
import { useMewsConfiguration } from "@/contexts/MewsConfigurationContext";

const TestMewsConfig: React.FC = () => {
  const {
    configuration,
    hotels,
    paymentConfiguration,
    isLoading,
    isLoaded,
    error,
    reload,
  } = useMewsConfiguration();

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 space-y-6">
      <h1 className="text-2xl font-semibold">Mews Configuration Context Test</h1>

      <div className="space-x-3">
        <button
          type="button"
          onClick={() => reload()}
          className="rounded-md bg-black text-white px-4 py-2 text-sm font-medium hover:bg-black/80"
        >
          Reload (bypass cache)
        </button>
      </div>

      <div className="space-y-2 text-sm">
        <p>
          <span className="font-semibold">Loading:</span>{" "}
          {isLoading ? "true" : "false"}
        </p>
        <p>
          <span className="font-semibold">Loaded:</span>{" "}
          {isLoaded ? "true" : "false"}
        </p>
        <p>
          <span className="font-semibold">Has error:</span>{" "}
          {error ? error.Message : "none"}
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 text-sm">
        <div className="border rounded-md p-4">
          <h2 className="font-semibold mb-2">Configuration</h2>
          {configuration ? (
            <ul className="space-y-1">
              <li>
                <span className="font-medium">Currency:</span>{" "}
                {configuration.Currency ?? "n/a"}
              </li>
              <li>
                <span className="font-medium">Check-in time:</span>{" "}
                {configuration.CheckInTime ?? "n/a"}
              </li>
              <li>
                <span className="font-medium">Check-out time:</span>{" "}
                {configuration.CheckOutTime ?? "n/a"}
              </li>
              <li>
                <span className="font-medium">Age categories:</span>{" "}
                {configuration.AgeCategories?.length ?? 0}
              </li>
              <li>
                <span className="font-medium">Policies:</span>{" "}
                {configuration.Policies?.length ?? 0}
              </li>
            </ul>
          ) : (
            <p className="text-muted-foreground">No configuration loaded.</p>
          )}
        </div>

        <div className="border rounded-md p-4">
          <h2 className="font-semibold mb-2">Hotel</h2>
          {hotels ? (
            <ul className="space-y-1">
              <li>
                <span className="font-medium">Hotel ID:</span> {hotels.Id}
              </li>
              <li>
                <span className="font-medium">Default currency:</span>{" "}
                {hotels.DefaultCurrencyCode}
              </li>
              <li>
                <span className="font-medium">Room categories:</span>{" "}
                {hotels.RoomCategories?.length ?? 0}
              </li>
              <li>
                <span className="font-medium">Products:</span>{" "}
                {hotels.Products?.length ?? 0}
              </li>
            </ul>
          ) : (
            <p className="text-muted-foreground">No hotel data loaded.</p>
          )}
        </div>

        <div className="border rounded-md p-4 md:col-span-2">
          <h2 className="font-semibold mb-2">Payment Configuration</h2>
          {paymentConfiguration ? (
            <ul className="space-y-1">
              <li>
                <span className="font-medium">Gateway type:</span>{" "}
                {paymentConfiguration.PaymentGateway.PaymentGatewayType}
              </li>
              <li>
                <span className="font-medium">Card storage type:</span>{" "}
                {paymentConfiguration.PaymentGateway.PaymentCardStorageType}
              </li>
              <li>
                <span className="font-medium">Is merchant:</span>{" "}
                {paymentConfiguration.PaymentGateway.IsMerchant
                  ? "true"
                  : "false"}
              </li>
            </ul>
          ) : (
            <p className="text-muted-foreground">
              No payment configuration loaded.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestMewsConfig;

